import { createContext } from 'react'

export interface _StepperProgressState {
  activeStepIndex: number
  trackElement: HTMLDivElement | null
}

export const _INITIAL_STEPPER_PROGRESS_STATE: _StepperProgressState = {
  activeStepIndex: 0,
  trackElement: null,
}

const _StepperProgressContext = createContext<_StepperProgressState>(_INITIAL_STEPPER_PROGRESS_STATE)

export default _StepperProgressContext
